<template>
	<b-sidebar
		id="add-new-user-sidebar"
		:visible="isAddNewPageSidebarActive"
		bg-variant="white"
		sidebar-class="sidebar-lg"
		shadow
		backdrop
		no-header
		right
		@hidden="resetForm"
		@change="val => $emit('update:is-add-new-page-sidebar-active', val)"
	>
		<template #default="{ hide }">
			<!-- Header -->
			<div
				class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
			>
				<h5 class="mb-0">
					{{
						props.typeForm === 'add'
							? 'Add New'
							: props.typeForm === 'edit'
							? 'Edit'
							: 'Detail'
					}}
				</h5>

				<feather-icon
					class="ml-1 cursor-pointer"
					icon="XIcon"
					size="16"
					@click="hide"
				/>
			</div>
			<!-- BODY -->
			<validation-observer #default="{ handleSubmit }" ref="refFormObserver">
				<!-- Form -->
				<b-form
					class="p-2"
					@submit.prevent="handleSubmit(onSubmit)"
					@reset.prevent="resetForm"
				>
					<!-- Full Name -->
					<validation-provider
						#default="validationContext"
						name="Kode Voucher"
						rules="required"
					>
						<b-form-group label="Kode Voucher" label-for="discount-code">
							<b-form-input
								id="discount-code"
								v-model="form.code"
								autofocus
								:state="getValidationState(validationContext)"
								trim
								placeholder="Kode Voucher"
								:readonly="!canEdit"
							/>

							<b-form-invalid-feedback>
								{{ validationContext.errors[0] }}
							</b-form-invalid-feedback>
						</b-form-group>
					</validation-provider>
					<validation-provider
						#default="validationContext"
						name="Jenis"
						rules="required"
					>
						<b-form-group label="Jenis" label-for="type">
							<b-form-select
								id="type"
								v-model="form.type"
								autofocus
								:state="getValidationState(validationContext)"
								trim
								placeholder="Jenis Diskon"
								:readonly="!canEdit"
								:options="typeOptions"
							/>

							<b-form-invalid-feedback>
								{{ validationContext.errors[0] }}
							</b-form-invalid-feedback>
						</b-form-group>
					</validation-provider>
					<validation-provider
						#default="validationContext"
						name="Value"
						rules="required"
					>
						<b-form-group label="Value" label-for="value">
							<b-form-input
								id="value"
								v-model="form.value"
								autofocus
								:state="getValidationState(validationContext)"
								trim
								placeholder="Nilai Diskon"
								:readonly="!canEdit"
							/>

							<b-form-invalid-feedback>
								{{ validationContext.errors[0] }}
							</b-form-invalid-feedback>
						</b-form-group>
					</validation-provider>
					<validation-provider
						#default="validationContext"
						name="Deskripsi"
						rules=""
					>
						<b-form-group label="Deskripsi" label-for="description">
							<b-form-input
								id="description"
								v-model="form.description"
								autofocus
								:state="getValidationState(validationContext)"
								trim
								placeholder="Deskripsi"
								:readonly="!canEdit"
							/>

							<b-form-invalid-feedback>
								{{ validationContext.errors[0] }}
							</b-form-invalid-feedback>
						</b-form-group>
					</validation-provider>
					<validation-provider
						#default="validationContext"
						name="Minimal Transaksi"
						rules=""
					>
						<b-form-group
							label="Minimal Transaksi"
							label-for="minimal_transaction_value"
						>
							<b-form-input
								id="minimal_transaction_value"
								v-model="form.min_transaction_value"
								autofocus
								:state="getValidationState(validationContext)"
								trim
								placeholder="Minimal Transaksi"
								:readonly="!canEdit"
							/>

							<b-form-invalid-feedback>
								{{ validationContext.errors[0] }}
							</b-form-invalid-feedback>
						</b-form-group>
					</validation-provider>
					<validation-provider
						#default="validationContext"
						name="Mulai Berlaku"
						rules=""
					>
						<b-form-group label="Mulai Berlaku" label-for="start_date">
							<b-form-datepicker
								id="start_date"
								v-model="form.start_date"
								autofocus
								:state="getValidationState(validationContext)"
								trim
								placeholder="Tanggal Mulai Berlaku"
								:readonly="!canEdit"
							/>

							<b-form-invalid-feedback>
								{{ validationContext.errors[0] }}
							</b-form-invalid-feedback>
						</b-form-group>
					</validation-provider>
					<validation-provider
						#default="validationContext"
						name="Tanggal Expired"
						rules=""
					>
						<b-form-group label="Tanggal Expired" label-for="expire_date">
							<b-form-datepicker
								id="expired_date"
								v-model="form.expire_date"
								autofocus
								:state="getValidationState(validationContext)"
								trim
								placeholder="Tanggal Expired Voucher"
								:readonly="!canEdit"
							/>

							<b-form-invalid-feedback>
								{{ validationContext.errors[0] }}
							</b-form-invalid-feedback>
						</b-form-group>
					</validation-provider>
					<validation-provider
						#default="validationContext"
						name="Jumlah Redem"
						rules=""
					>
						<b-form-group label="Jumlah Redem" label-for="limit_number_redemptions">
							<b-form-input
								id="limit_number_redemptions"
								v-model="form.limit_number_redemptions"
								autofocus
								:state="getValidationState(validationContext)"
								trim
								placeholder="Jumlah Redem"
								:readonly="!canEdit"
								type="number"
							/>

							<b-form-invalid-feedback>
								{{ validationContext.errors[0] }}
							</b-form-invalid-feedback>
						</b-form-group>
					</validation-provider>
					<!-- Form Actions -->
					<div v-if="props.typeForm !== 'show'" class="d-flex mt-2">
						<b-button
							v-ripple.400="'rgba(255, 255, 255, 0.15)'"
							variant="primary"
							class="mr-2"
							type="submit"
							:disabled="isLoading"
						>
							<span>Submit</span>
							<b-spinner v-if="isLoading" small class="ml-1" />
						</b-button>
						<b-button
							v-ripple.400="'rgba(186, 191, 199, 0.15)'"
							type="button"
							variant="outline-secondary"
							@click="hide"
						>
							Cancel
						</b-button>
					</div>
				</b-form>
			</validation-observer>
		</template>
	</b-sidebar>
</template>

<script>
import {
	BSidebar,
	BForm,
	BFormGroup,
	BFormInput,
	BFormInvalidFeedback,
	BButton,
	BModal,
	BFormSelect,
	BFormDatepicker,
	BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import inject, { ref, watch } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/@fake-db/data/other/countries'
import { typeVoucherOptions } from '@core/utils/constant'

export default {
	components: {
		Password: () => import('vue-password-strength-meter'),
		DatePicker: () => import('vue2-datepicker'),
		BSidebar,
		BForm,
		BModal,
		BFormGroup,
		BFormInput,
		BFormSelect,
		BFormInvalidFeedback,
		BFormDatepicker,
		BButton,
		vSelect,
		BSpinner,

		// Form Validation
		ValidationProvider,
		ValidationObserver,
	},
	directives: {
		Ripple,
	},
	model: {
		prop: 'isAddNewPageSidebarActive',
		event: 'update:is-add-new-page-sidebar-active',
	},
	props: {
		isAddNewPageSidebarActive: {
			type: Boolean,
			required: true,
		},
		typeForm: {
			type: String,
			default: 'add',
		},
		data: {
			type: Object,
			default: null,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			required,
			alphaNum,
			email,
			countries,
		}
	},
	setup(props, { emit }) {
		const blankFormData = {
			type: null,
			code: null,
			value: null,
			description: null,
			min_transaction_value: null,
			start_date: null,
			expire_date: null,
			limit_number_redemptions: null,
		}

		const typeOptions = ref([
			...{
				text: 'Pilih Jenis Diskon',
				value: null,
			},
			...typeVoucherOptions,
		])

		const canEdit = ref(true)

		const form =
			props.data !== null
				? ref(props.data)
				: ref(JSON.parse(JSON.stringify(blankFormData)))
		const resetpageData = () => {
			form.value = JSON.parse(JSON.stringify(blankFormData))
		}

		watch(
			() => props.isAddNewPageSidebarActive,
			(newValue, prevValue) => {
				if (props.typeForm === 'edit') {
					canEdit.value = true
					form.value = props.data
				} else if (props.typeForm === 'show') {
					canEdit.value = false
					form.value = props.data
				} else {
					canEdit.value = true
					form.value = JSON.parse(JSON.stringify(blankFormData))
				}
			},
		)

		const onSubmit = () => {
			console.log(props.typeForm)
			if (props.typeForm === 'add') {
				console.log('add')
				emit('onSubmit', form.value)
			} else {
				const temp = {
					id: props.data.id,
					type: form.value.type,
					code: form.value.code,
					value: form.value.value,
					description: form.value.description,
					min_transaction_value: form.value.min_transaction_value,
					start_date: form.value.start_date,
					expire_date: form.value.expire_date,
					limit_number_redemptions: form.value.limit_number_redemptions,
				}
				emit('onSubmit', temp)
			}
		}

		const { refFormObserver, getValidationState, resetForm } =
			formValidation(resetpageData)

		return {
			tglLahir: null,
			onSubmit,
			refFormObserver,
			getValidationState,
			resetForm,
			canEdit,
			props,
			typeOptions,

			form,
		}
	},
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
	.vs__dropdown-menu {
		max-height: 200px !important;
	}
}
</style>
